// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"3154de31","455":"ae8c6aaa","977":"f3cbd421"}[chunkId] + ".chunk.js";
};